import { RefObject, useCallback, useLayoutEffect, useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import { Size } from 'ff-canvas';
import { useDebounce } from './useDebounce';

export const useSize = (target: RefObject<HTMLElement> | null, wait: number = 250) => {

    const [size, setSize] = useState<Size | undefined>();

    const updateSize = useCallback(({ width, height }: Size) => {

        if (width !== 0 && height !== 0
            && !isRoughlySameSize({ width, height }, size)) {

            setSize({
                width: Math.floor(width),
                height: Math.floor(height)
            });
        }
    }, [size]);

    const debouncedUpdateSize = useDebounce(updateSize, wait, { leading: true, trailing: true });

    useLayoutEffect(() => {
        if (target?.current) {
            setSize(target.current.getBoundingClientRect());
        }
    }, [target]);

    useResizeObserver(target, entry => debouncedUpdateSize(entry.contentRect));

    return size;
};

const isRoughlySameSize = (a: Size | undefined, b: Size | undefined) => {
    return a && b
        && Math.floor(a.width) === Math.floor(b.width)
        && Math.floor(a.height) === Math.floor(b.height);
};